import { cn } from '@/lib/utils'
import React, { useCallback } from 'react'

export interface SoundWaveProps {
  waveData: number[]
  className?: string
  height?: number
  currentTime?: number
  duration?: number
  onSeek?: (time: number) => void
}

export default function SoundWave({
  waveData,
  className,
  height = 32,
  currentTime = 0,
  duration = 0,
  onSeek = () => {},
}: SoundWaveProps) {
  const progress = duration > 0 ? (currentTime / duration) * 100 : 0
  const progressIndex = Math.ceil((progress / 100) * waveData.length)

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation()
      const rect = event.currentTarget.getBoundingClientRect()
      const clickX = event.clientX - rect.left // Relative X position
      const barIndex = Math.floor((clickX / rect.width) * waveData.length)
      const time = (barIndex / waveData.length) * duration
      onSeek(time)
    },
    [duration, onSeek, waveData.length]
  )
  //'tw-mr-1 tw-rounded-full tw-bg-[var(--Primary-100)]  tw-transition-all tw-duration-100 tw-ease-in-out hover:tw-bg-[var(--Secondary)]'
  //'!tw-bg-[var(--Secondary)]': progressIndex > index,
  return (
    <div className={cn('tw-flex tw-items-center tw-justify-start', className)} style={{ height: `${height}px` }}>
      <div className="tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-items-center tw-justify-around" onClick={handleClick}>
        {waveData.map((value, index) => (
          <div
            key={index}
            className={cn(
              'tw-mr-1 tw-rounded-full tw-transition-all tw-duration-100 tw-ease-in-out hover:!tw-bg-white',
              {
                '!tw-bg-white': progressIndex > index,
              }
            )}
            style={{
              height: `${value}%`,
              width: `3px`,
              backgroundColor: 'var(--Primary-300)',
            }}
          />
        ))}
      </div>
    </div>
  )
}
